import React, { useMemo } from 'react'
import { ensureString, getHomeFullImageCallout, logEvent } from '../../Utils'
import { CardConStyle } from './styles'
import { Img } from '../Image/Img'
import { ANALYTICS_TAGS } from '../../Constants/analytics'
import { Lk } from '../Links/Lk'
import { BrazeContentCard } from '../../Hooks'

type DefaultCardData = {
  title?: string
  linkText?: string | unknown
  imageUrl?: string
  url?: string
  location?: string
}

type CalloutProps = {
  location: string
  cardData?: DefaultCardData | BrazeContentCard
}


export const FullImageCard: React.FC<React.PropsWithChildren<CalloutProps>> = ({
  location,
  cardData,
}) => {
  const card = useMemo(() => {
      if (!cardData) {
        return getHomeFullImageCallout(location)
      }

      //Braze Content Card
      if ('extras' in cardData) {
        return {
          title: cardData.title,
          imageUrl: cardData.imageUrl,
          url: cardData.url,
          linkText: ensureString(cardData.extras?.linkText) ?? 'Go Now',
          location: location,
        }
      }
      return cardData
  }, [cardData])

  const log = () => {
    logEvent(
      ANALYTICS_TAGS.callout_card_click,
      {
        title: card.title,
        section: 'home_callout',
        card_location: location,
        btn_text: card.linkText,
        link: card.url
      }
    )
  }

  return (
    <CardConStyle>
      {card.imageUrl && <Img src={card.imageUrl} alt={card.title ?? 'Card Featured'} />}
      {card.url && (
        <Lk
          link={card.url}
          alt={`${card?.linkText} - ${card?.title}`}
          onClick={log}
          classNameObj={'btn'}
          role="button"
        >
          {`${card?.linkText ?? 'Go Now'}`}
        </Lk>
      )}
    </CardConStyle>
  )
}
